import { useMemo } from 'react'

import { useLocation } from 'react-router-dom'

import { getSportByUrlParam } from '@/config/sports'

export const useQueryParams = () => {
  const location = useLocation()

  return useMemo(() => {
    const params = new URLSearchParams(location.search)
    const blackout = params.get('blackout') === 'true'
    const sportParam = params.get('sport')
    const sport = sportParam ? getSportByUrlParam(sportParam) : undefined

    // ?res=720|1080|4k overrides viewport-based scaling with fixed dimensions
    const resParam = params.get('res')
    let resOverride: { height: number; width: number } | undefined
    if (resParam) {
      const height = resParam.toLowerCase() === '4k' ? 2160 : parseInt(resParam)
      if (height) {
        const width = Math.round(height * (16 / 9))
        document.documentElement.style.fontSize = `${height / 108}px`
        resOverride = { height, width }
      }
    }

    return {
      blackout,
      sport,
      resOverride,
    }
  }, [location.search])
}
